export default function MetricCard({ metric }) {
	return (
		<div className="stat-card">
			<p className="stat-label">{metric.label}</p>
			<div className="stat-value-row">
				<span className="stat-value">{metric.value}</span>
				<span className="stat-trend">{metric.trend}</span>
			</div>
		</div>
	);
}
